import type { ComponentType } from "react";
import { Navigate, useParams } from "react-router-dom";
import ToolLayout from "../components/tools/ToolLayout";
import HDPriceDecoderTool from "../components/tools/HDPriceDecoderTool";
import DGPennyListTool from "../components/tools/DGPennyListTool";
import HDPennyCheckerTool from "../components/tools/HDPennyCheckerTool";
import DGCouponCalculatorTool from "../components/tools/DGCouponCalculatorTool";
import ResaleProfitTool from "../components/tools/ResaleProfitTool";
import TargetClearanceTool from "../components/tools/TargetClearanceTool";
import { getToolBySlug, type ToolSlug } from "../seo/tools";

const WIDGETS: Record<ToolSlug, ComponentType> = {
  "home-depot-price-decoder": HDPriceDecoderTool,
  "dollar-general-penny-list": DGPennyListTool,
  "home-depot-penny-checker": HDPennyCheckerTool,
  "dollar-general-coupon-calculator": DGCouponCalculatorTool,
  "resale-profit-calculator": ResaleProfitTool,
  "target-clearance-decoder": TargetClearanceTool,
};

const CTAS: Partial<Record<ToolSlug, { title: string; body: string; label?: string }>> = {
  "dollar-general-penny-list": {
    title: "Penny items at your Dollar General",
    body: "DealHawk confirms penny items store by store and shows which of your stores have them, plus deep markdowns and coupon deals.",
  },
  "home-depot-penny-checker": {
    title: "Stop checking SKUs one at a time",
    body: "Penny Pro lists likely penny items for each Home Depot near you, with on-hand counts and aisle locations.",
  },
  "resale-profit-calculator": {
    title: "Find clearance worth flipping",
    body: "DealHawk shows clearance at the stores near you next to what each item resells for on Amazon and eBay.",
  },
};

export default function ToolPage() {
  const { slug } = useParams<{ slug: string }>();
  const tool = slug ? getToolBySlug(slug) : undefined;
  if (!tool) return <Navigate to="/tools" replace />;
  const Widget = WIDGETS[tool.slug];
  return (
    <ToolLayout tool={tool} cta={CTAS[tool.slug]}>
      <Widget />
    </ToolLayout>
  );
}
